/**
 * localizationResolver — Safe i18n Key Resolver
 *
 * Resolves a dot-notation i18n key to its English string value by traversing
 * the statically-bundled en.json object.  This is the last-resort fallback
 * that prevents raw keys (e.g. "admin.localization.title") from ever reaching
 * the UI, even if Vue I18n or the backend translation API is unavailable.
 *
 * Examples:
 *   resolveLocalizationKey("nav.dashboard")       → "Dashboard"
 *   resolveLocalizationKey("admin.localization.title")  → "Localization Settings"
 *   resolveLocalizationKey("unknown.key")          → "unknown.key"  (safe fallback)
 */
import { masterLocalization } from "@/localization/masterLocalization";

/**
 * Traverse a dot-notation key through the en.json hierarchy and return the
 * matching string value, or the key itself if nothing is found.
 */
export function resolveLocalizationKey(key: string): string {
  if (!key) return key;

  const parts = key.split(".");
  let cur: unknown = masterLocalization;

  for (const part of parts) {
    if (typeof cur !== "object" || cur === null) return key;
    cur = (cur as Record<string, unknown>)[part];
  }

  return typeof cur === "string" ? cur : key;
}
